import {
  PatientEhrType,
  PatientInfoType,
  PatientOrgInfoType,
} from "DataTypes/Redux";
import {
  ADD_PATIENT_INFO,
  CLEAR_PATIENT_INFO,
  CLEAR_PATIENT,
  ADD_SELECTED_PRGM_INFO,
  CLEAR_SELECTED_PRGM_INFO,
  ADD_PATIENT_ORG_INFO,
  CLEAR_PATIENT_ORG_INFO,
  ADD_SELECTED_TRAINING_INFO,
  CLEAR_SELECTED_TRAINING_INFO,
  ADD_SELECTED_DEVICE_INFO,
  CLEAR_SELECTED_DEVICE_INFO,
  ADD_RPM_PRGM_INFO,
  CLEAR_RPM_PRGM_INFO,
  ADD_PRGM_ARR,
  CLEAR_PRGM_ARR,
  SET_PATIENT_EHR,
  SET_PATIENT_EHR_ACTIVE_SYNC,
  SET_PATIENT_EHR_SYNC_SIGNAL,
  CLEAR_PATIENT_EHR,
} from "./type";
import { FormatEligiblePrgmType } from "DataTypes/PatientManagement.type";
import {
  PatientDeviceDetails,
  PatientDeviceTrainingType,
} from "DataTypes/Services/Patient.type";
import { PrgmListResType } from "DataTypes/Services/Prgm.type";

export const addPatientInfo: (data: PatientInfoType) => {
  type: string;
  payload: PatientInfoType;
} = (data) => {
  return {
    type: ADD_PATIENT_INFO,
    payload: data,
  };
};

export const clearPatientInfo: () => {
  type: string;
} = () => {
  return {
    type: CLEAR_PATIENT_INFO,
  };
};

export const addEligiblePrgmArr: (data: PrgmListResType[]) => {
  type: string;
  payload: PrgmListResType[];
} = (data) => {
  return {
    type: ADD_PRGM_ARR,
    payload: data,
  };
};

export const clearEligiblePrgmArr: () => {
  type: string;
} = () => {
  return {
    type: CLEAR_PRGM_ARR,
  };
};

export const addPatientOrgInfo: (data: PatientOrgInfoType) => {
  type: string;
  payload: PatientOrgInfoType;
} = (data) => {
  return {
    type: ADD_PATIENT_ORG_INFO,
    payload: data,
  };
};

export const clearPatientOrgInfo: () => {
  type: string;
} = () => {
  return {
    type: CLEAR_PATIENT_ORG_INFO,
  };
};

export const addSelectedPrgm: (data: FormatEligiblePrgmType) => {
  type: string;
  payload: FormatEligiblePrgmType;
} = (data) => {
  return {
    type: ADD_SELECTED_PRGM_INFO,
    payload: data,
  };
};

export const clearSelectedPrgm: () => {
  type: string;
} = () => {
  return {
    type: CLEAR_SELECTED_PRGM_INFO,
  };
};

export const addRPMPrgm: (data: FormatEligiblePrgmType) => {
  type: string;
  payload: FormatEligiblePrgmType;
} = (data) => {
  return {
    type: ADD_RPM_PRGM_INFO,
    payload: data,
  };
};

export const clearRPMPrgm: () => {
  type: string;
} = () => {
  return {
    type: CLEAR_RPM_PRGM_INFO,
  };
};

export const clearPatient: () => {
  type: string;
} = () => {
  return {
    type: CLEAR_PATIENT,
  };
};
export const addSelectedTraining: (data: PatientDeviceTrainingType) => {
  type: string;
  payload: PatientDeviceTrainingType;
} = (data) => {
  return {
    type: ADD_SELECTED_TRAINING_INFO,
    payload: data,
  };
};

export const clearSelectedTraining: () => {
  type: string;
} = () => {
  return {
    type: CLEAR_SELECTED_TRAINING_INFO,
  };
};

export const addSelectedDevice: (data: PatientDeviceDetails) => {
  type: string;
  payload: PatientDeviceDetails;
} = (data) => {
  return {
    type: ADD_SELECTED_DEVICE_INFO,
    payload: data,
  };
};

export const clearSelectedDevice: () => {
  type: string;
} = () => {
  return {
    type: CLEAR_SELECTED_DEVICE_INFO,
  };
};

export const setPatientEhr: (data: Partial<PatientEhrType>) => {
  type: string;
  payload: Partial<PatientEhrType>;
} = (data) => {
  return {
    type: SET_PATIENT_EHR,
    payload: data,
  };
};

/**
 * Which EHR Sync button is mid-request. Pass null to mean "none" - this never
 * reaches the sync endpoint, it only drives the per-button spinner.
 */
export const setPatientEhrActiveSync: (domain: string | null) => {
  type: string;
  payload: string | null;
} = (domain) => {
  return {
    type: SET_PATIENT_EHR_ACTIVE_SYNC,
    payload: domain,
  };
};

/**
 * Announces that a sync of `domain` just succeeded. Sections on screen watch
 * this and reload when the domain is theirs or "all"; the reducer does the
 * counting, so this stays a plain creator.
 */
export const setEhrSyncSignal: (domain: string) => {
  type: string;
  payload: string;
} = (domain) => {
  return {
    type: SET_PATIENT_EHR_SYNC_SIGNAL,
    payload: domain,
  };
};

export const clearPatientEhr: () => {
  type: string;
} = () => {
  return {
    type: CLEAR_PATIENT_EHR,
  };
};
